import React, { memo } from 'react'

import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import formatResultsCount, { formatExactCount } from 'Pods/SearchPage/Shared/formatResultsCount'
import useTranslate, { useLocale } from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

const VIEWPORT_GUTTER = 8

// Below md the count sits flush with the page's left edge, where a centred tooltip overflows the
// viewport; keep it inside the gutter on both sides.
const clampToViewport = ({ left, top }, _event, _target, node) => ({
  left: Math.max(VIEWPORT_GUTTER, Math.min(left, window.innerWidth - node.offsetWidth - VIEWPORT_GUTTER)),
  top,
})

function ResultsCount() {
  const translate = useTranslate()
  const locale = useLocale()
  const totalCount = useSearchPageStore(state => state.meta.totalCount) || 0

  const label = translate('search_page.results.models_count', {
    count: totalCount,
    total: formatResultsCount(totalCount, locale),
  })
  const exactLabel = translate('search_page.results.models_count', {
    count: totalCount,
    total: formatExactCount(totalCount, locale),
  })

  const labelNode = <span className="results-count__label cgt-caption-semibold">{label}</span>

  // aria-hidden: Results' always-mounted role="status" region already announces the exact count.
  return (
    <div className="results-count" aria-hidden="true">
      {label === exactLabel ? labelNode : (
        <Tooltip
          id="search-page-results-count"
          content={exactLabel}
          place="bottom"
          tooltipClassName="results-count__tooltip"
          overridePosition={clampToViewport}
        >
          {labelNode}
        </Tooltip>
      )}
    </div>
  )
}

export default memo(ResultsCount)
